import { Space, Table, Button, Col, Row, Statistic, Modal, Descriptions, Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { formatDate } from 'utils/date';
import { formatCurrency } from 'utils/number';
import Debt from '../Debt';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import CustomerLoginEdit from 'components/customer/CustomerLoginEdit';
import _ from 'lodash';

const DesktopInfoModal = ({
  isModalOpen,
  customer,
  orders,
  showCustomerEdit,
  setShowCustomerEdit,
  showCustomerLoginEdit,
  setShowCustomerLoginEdit,
  isAccountLoginMode,
  handleCancel,
  onCustomerSave,
}) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: 'Mã đơn hàng',
      render: (record) => (
        <Space direction="vertical">
          <Button type="text" onClick={() => navigate(`/order/${record.id}`)}>
            {record.id}
          </Button>
          <div>{formatDate(record.create_on)}</div>
        </Space>
      ),
    },
    {
      title: 'Sản phẩm',
      render: (record) => (
        <Space direction="vertical">
          <div>{record.total_item}</div>
          <div>{formatCurrency(record.total_amount)}</div>
        </Space>
      ),
    },
    {
      title: 'Trạng thái',
      render: (record) => (
        <Space direction="vertical">
          {record.status === 'canceled' && <div>Đã Huỷ</div>}
          {record.status === 'finalized' && <div>Đã Hoàn tất</div>}
          {!['canceled', 'finalized'].includes(record.status) && <div>Đang xử lý</div>}
        </Space>
      ),
    },
  ];

  const items = [
    {
      key: 'order',
      label: 'Đơn hàng',
      children: <Table dataSource={orders} columns={columns} scroll={{ y: 300 }} />,
    },
    {
      key: 'debt',
      label: 'Công nợ',
      children: <Debt customer={customer} onChange={onCustomerSave} />,
    },
  ];

  return (
    <>
      <Modal
        title="Thông tin khách hàng sd"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onCancel={handleCancel}
        width="50%"
        footer={
          <Space>
            <Button type="link" onClick={() => setShowCustomerEdit(true)}>
              Cập nhật thông tin 2
            </Button>
            {isAccountLoginMode && (
              <Button type="link" onClick={() => setShowCustomerLoginEdit(true)}>
                Quản lý đăng nhập 2
              </Button>
            )}
            <Button onClick={handleCancel}>Close</Button>
          </Space>
        }
      >
        <Space style={{ width: '100%' }} direction="vertical">
          <Descriptions column={1}>
            <Descriptions.Item label="Họ và tên">{customer.full_name}</Descriptions.Item>
            <Descriptions.Item label="SDT">{customer.phone}</Descriptions.Item>
            <Descriptions.Item label="Địa chỉ" span={3}>
              {customer.address}
            </Descriptions.Item>
          </Descriptions>

          <Row gutter={16}>
            <Col flex="25%">
              <Statistic title="Đơn hàng" value={orders.length} />
            </Col>
            <Col flex="25%">
              <Statistic
                title="Số tiền"
                value={_.sumBy(orders, (x) => x.total_amount ?? 0)}
                precision={0}
              />
            </Col>
            <Col flex="25%">
              <Statistic title="Xu" value={customer.loyalty_point?.current ?? 0} precision={0} />
            </Col>
            {customer.debt?.current_debt !== 0 && (
              <Col flex="25%">
                <Statistic title="Nợ" value={customer.debt?.current_debt ?? 0} precision={0} />
              </Col>
            )}
          </Row>
          <Tabs items={items} />
        </Space>
      </Modal>

      <CustomerInfoEdit
        id={customer.id}
        open={showCustomerEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerEdit(false)}
      />
      <CustomerLoginEdit
        id={customer.id}
        open={showCustomerLoginEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerLoginEdit(false)}
      />
    </>
  );
};

export default DesktopInfoModal;
